import React from 'react'
import ReactDOM from 'react-dom'
import {BrowserRouter} from 'react-router-dom'
import App from 'App'
import 'styles/index.css'

ReactDOM.render(<BrowserRouter basename='/buildiroAcc/#/'><App/></BrowserRouter>, document.getElementById('root'))
